import React from 'react';
import styles from './messages.scss';
import navigationService from '../../services/NavigationService';
import { t } from '../../services/i18nService';

class ExitButton extends React.PureComponent {
    render() {
        return (
            <button
                className={styles.exitButton}
                onClick={navigationService.exitFromMessages}
                aria-label={t('messages.exitButton.ariaLabelText')}
            >
                <i className="fa fa-close fa-3" />
            </button>
        );
    }
}

export default ExitButton;
